<template>
  <div class="zhujue" >
    <hear></hear>
    <div class="name1">
      <div class="name2">
        <el-row class="tac">
          <el-tabs class="tac" tab-position="left">
            <el-tab-pane  style="height: 100%;" label="代理公司列表">
              <information style="height: 100%;" ></information>
            </el-tab-pane>
            <!-- <el-tab-pane label="申请代理">
              <applicationAgent></applicationAgent>
            </el-tab-pane> -->
          </el-tabs>
        </el-row>
      </div>
    </div>
    <binad></binad>
  </div>
</template>

<script>
import hear from ".././../components/hear.vue";
import information from "./information.vue";
import applicationAgent from "./applicationAgent.vue";
import binad from ".././../components/dinad.vue";
export default {
  components: {
    hear,
    // Notice,
    information,
    applicationAgent,
    binad
  },
  name: "agenciesName",
  data() {
    return {
      weidaili_params: {
        limit: 10,
        offset: 0,
        keywords: "",
        user_id: sessionStorage.getItem("user_id")
      },
      weidaili_list: [],
      weidaili_total: null,
      daili_params: {
        limit: 10,
        offset: 0,
        keywords: "",
        user_id: sessionStorage.getItem("user_id")
      },
      daili_list: [],
      daili_total: null
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.search {
  float: right;
  width: 15%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;
  .el-button {
    border: none;
  }
}

.fl {
  display: flex;
}

.justify-content {
  justify-content: center;
}

.align-items {
  align-items: center;
}
::v-deep .el-tabs__nav-scroll {
  padding-top: 40px;
}
::v-deep .el-tabs__content{
  height: 100% !important;
}
::v-deep .el-tabs__item.is-active {
  color: #fff !important;
  background-color: #409eff !important;
}
.name1 {
  // height: 100vh;
  flex:1;
  display: flex;
  flex-direction: column;
//  min-height: calc(100vh - 69px);
  background-color: #f5f6fa;
}
.name2 {
  width: 100%;
  height: 100%;
  background: #ffffff;
  // padding: 0 2%;
  flex: 1;
  margin-top: 3px;
}
.name3 {
  background-color: #ffffff;
  height: 100%;
}
.tac {
  height: 100%;
}

</style>


// WEBPACK FOOTER //
// src/view/agencies/agenciesName.vue